import { __read, __spreadArray } from "tslib";
import { useCallback, useMemo } from 'react';
import { useAccordionFilters } from './useAccordionFilters';
import { useTabsFilter } from './useTabsFilter';
export function useAllFilters(_a) {
    var locResources = _a.locResources, identity = _a.identity, onSelectFilter = _a.onSelectFilter, onSelectTab = _a.onSelectTab, fileType = _a.fileType, fluidSupportEnabled = _a.fluidSupportEnabled, linksEnabled = _a.linksEnabled, customPivots = _a.customPivots, getCustomPivotTitle = _a.getCustomPivotTitle, getCustomPivotIconElement = _a.getCustomPivotIconElement, getTagIdByTagValue = _a.getTagIdByTagValue, PendingCustomPivotId = _a.PendingCustomPivotId, activeCustomPivotTabId = _a.activeCustomPivotTabId, fetchPictureData = _a.fetchPictureData, tagMap = _a.tagMap, msaUserHint = _a.msaUserHint, onPivotRefChange = _a.onPivotRefChange, filtersConfig = _a.filtersConfig, customFiltersEnabled = _a.customFiltersEnabled;
    var tabsFilter = useTabsFilter(locResources, onSelectTab, customPivots, getCustomPivotTitle, getCustomPivotIconElement, PendingCustomPivotId, activeCustomPivotTabId, fetchPictureData, tagMap, identity, msaUserHint, getTagIdByTagValue, onPivotRefChange, filtersConfig, customFiltersEnabled);
    var accordionFilter = useAccordionFilters({
        locResources: locResources,
        identity: identity,
        fileType: fileType,
        fluidSupportEnabled: fluidSupportEnabled,
        linksEnabled: linksEnabled,
        currentTab: tabsFilter.currentTab,
        onSelectFilter: onSelectFilter,
        msaUserHint: msaUserHint,
    });
    var appendToFilterFunctions = useCallback(function (filterFunctions, activeFilters, isMultiSelect) {
        if (!activeFilters.length) {
            return;
        }
        filterFunctions.push(isMultiSelect
            ? function (document) {
                return activeFilters.some(function (filterModel) {
                    return filterModel.filterFunction(document);
                });
            }
            : function (document) {
                return activeFilters.every(function (filterModel) {
                    return filterModel.filterFunction(document);
                });
            });
    }, []);
    var filterFunctions = useMemo(function () {
        var memoizedFunctions = [
            // TODO: Should deleted files be visible but not interactable?
            function (doc) { return !doc.isDeleted; },
        ];
        appendToFilterFunctions(memoizedFunctions, tabsFilter.activeFilters, false);
        appendToFilterFunctions(memoizedFunctions, accordionFilter.filesFilter.activeFilters, true);
        appendToFilterFunctions(memoizedFunctions, accordionFilter.activitiesFilter.activeFilters, true);
        appendToFilterFunctions(memoizedFunctions, accordionFilter.dateFilter.activeFilters, false);
        return memoizedFunctions;
    }, [
        accordionFilter.activitiesFilter.activeFilters,
        accordionFilter.dateFilter.activeFilters,
        accordionFilter.filesFilter.activeFilters,
        appendToFilterFunctions,
        tabsFilter.activeFilters,
    ]);
    var resetAllFilters = useCallback(function () {
        accordionFilter.resetFilterFunctions();
    }, [accordionFilter]);
    var hasActiveFilters = useMemo(function () {
        return ((!fileType &&
            accordionFilter.filesFilter.activeFilters.length > 0) ||
            accordionFilter.dateFilter.activeFilters.length > 0 ||
            accordionFilter.activitiesFilter.activeFilters.length > 0);
    }, [accordionFilter, fileType]);
    var allFilters = useMemo(function () {
        var _a;
        return ({
            tabsFilter: tabsFilter,
            filterFunctions: filterFunctions,
            allFilterModels: __spreadArray(__spreadArray(__spreadArray(__spreadArray([], __read(tabsFilter.activeFilters), false), __read(accordionFilter.activitiesFilter.activeFilters), false), __read(accordionFilter.dateFilter.activeFilters), false), __read(accordionFilter.filesFilter.activeFilters), false),
            resetAllFilters: resetAllFilters,
            hasActiveFilters: hasActiveFilters,
            accordionFilter: accordionFilter,
            showHidden: (_a = accordionFilter.showHidden) !== null && _a !== void 0 ? _a : false,
        });
    }, [
        tabsFilter,
        filterFunctions,
        resetAllFilters,
        hasActiveFilters,
        accordionFilter,
    ]);
    return allFilters;
}
//# sourceMappingURL=useAllFilters.js.map